/* Make the existing provider controls clearer without changing coverage, prices or checkout actions. */
(() => {
  const setText = (selector, text) => {
    const element = document.querySelector(selector);
    if (element && element.textContent !== text) element.textContent = text;
  };

  const enhance = () => {
    setText('#xcottonModalWrapper .xcotton-pp-modal__info-title', 'Optional product protection');
    setText('#xcottonModalWrapper .xcotton-pp-modal__info-subtitle', 'An optional paid add-on. Your existing warranty is unchanged.');
    setText('#xcotton-productProtection-noSubmit', 'Continue without extra protection');
    setText('#xcotton-productProtection-submit', 'Add selected protection plan');

    document.querySelectorAll('#xcotton-productProtection-noSubmit, #xcotton-productProtection-submit, [data-xmh-checkout-without="true"]').forEach(element => {
      if (element.dataset.spAccessible === 'true') return;
      element.dataset.spAccessible = 'true';
      element.setAttribute('role', 'button');
      element.setAttribute('tabindex', '0');
      element.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        element.click();
      });
    });
  };

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  });
  enhance();
  observer.observe(document.body, { childList: true, subtree: true });
})();
